import cx from "classnames";
import React, { PropsWithChildren } from "react";
import Typography from "@mui/material/Typography";
import {
  makeStyles,
  useIsMobileDevice,
  useIsTabletDown,
  useIsTabletOnly,
  useIsTabletUp,
  useTheme,
} from "../../theme/Theme";
import { RoundBackButton } from "../buttons/RoundBackButton";
import { AngleLeftIcon } from "../icons/AngleLeftIcon";
import { Breakpoints } from "../../dto/ApplicationDTO";

interface StylesProps {
  readonly isMobileDevice: boolean;
  readonly isSmallUp: boolean;
  readonly isSmallOnly: boolean;
}
const useStyles = makeStyles<StylesProps>((theme) => ({
  header: {
    display: (props) => "inline-flex",
    alignItems: "center",
    width: "fit-content",
    flexDirection: "row",
    [theme.breakpoints.down(Breakpoints.Tablet)]: {
      marginBottom: theme.typography.pxToRem(19),
    },
    [theme.breakpoints.up(Breakpoints.Tablet)]: {
      marginBottom: theme.typography.pxToRem(15),
    },
    [theme.breakpoints.up(Breakpoints.Laptop)]: {
      marginBottom: theme.typography.pxToRem(20),
    },
  },
  backButton: {
    marginRight: theme.typography.pxToRem(10),
  },
  backButtonTablet: {
    marginRight: theme.typography.pxToRem(20),
  },
  clickable: {
    cursor: "pointer",
    WebkitTapHighlightColor: "transparent",
    textDecoration: "none",
    userSelect: "none",
    appearance: "none",
  },
}));

interface Props {
  onBack: () => void;
}

export function DocumentsPageHeader({ onBack }: PropsWithChildren<Props>) {
  const isMobileDevice = useIsMobileDevice();
  const isSmallUp = useIsTabletUp();
  const isSmallDown = useIsTabletDown();
  const isSmallOnly = useIsTabletOnly();

  const theme = useTheme();
  const classes = useStyles({ isMobileDevice, isSmallOnly, isSmallUp });

  return (
    <div className={classes.header}>
      {isSmallDown ? (
        <RoundBackButton onClick={onBack} className={classes.backButtonMobile} />
      ) : (
        <div onClick={onBack} className={cx(classes.clickable, classes.header)}>
          <AngleLeftIcon color={theme.palette.gary.main} className={classes.backButton} />
          <Typography color={theme.palette.gary.main} variant="button1">
            Назад
          </Typography>
        </div>
      )}
    </div>
  );
}
